import { useContext, useEffect } from "react";
import { NavContext } from "../contexts/NavContextProvider";
import { updateDocumentTitle } from "..";
import SubPageTitle from "../SubPageTitle";
import { Breadcrumb, BreadcrumbButton, BreadcrumbDivider, BreadcrumbItem, Divider, makeStyles, Tab, TabList, tokens } from "@fluentui/react-components";
import { CircleMultipleConcentricFilled, bundleIcon, InfoFilled, InfoRegular, LockClosedKeyFilled, LockClosedKeyRegular } from "@fluentui/react-icons";
import FlightOps_Ring_Overview from "./components/FlightOps_Ring_Overview";
import { useParams } from "react-router";

const useStyles = makeStyles({
    navContentRoot: {
        display: "flex",
        width: "100%",
        height: "100%",
        marginTop: "1rem"
    },
    navContent__tabList: {
        minWidth: "200px",
        height: "100%",
        borderRight: "1px solid " + tokens.colorNeutralStroke1,

        "& .fui-Divider": {
            flexGrow: "0",
            padding: "0.5rem 0"
        }
    },
    navContentPane: {
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
        width: "100%",
        overflow: "hidden auto"
    }
});

const InfoIcon = bundleIcon(InfoFilled, InfoRegular);
const LockKeyIcon = bundleIcon(LockClosedKeyFilled, LockClosedKeyRegular);

const getPageTitle = ( id: string ) => {
    switch( id ) {
        case "overview": return "Overview";
    }

    return "Unknown Page";
};

export default function FlightOpsRingPage() {
    const params = useParams();
    const styles = useStyles();
    const { navData, setNavData } = useContext(NavContext);

    useEffect(
        () => {
            let subPage = window.location.hash.substring( 1 );
            if( !subPage.length )
                subPage = "overview";

            updateDocumentTitle( params.ringName + " | " + getPageTitle( subPage ) );
            navData.sidebarSelectedNavValue = "flightops";
            navData.subPageNavValue = subPage;
            setNavData({...navData});
        },
        []
    );
    
    const changeTab = ( tabValue: string ) => {
        navData.subPageNavValue = tabValue;
        setNavData( { ...navData } );

        updateDocumentTitle( params.ringName + " | " + getPageTitle( tabValue ) );
        window.location.hash = tabValue;
    };

    return (
        <>
            <Breadcrumb style={{ marginBottom: "1rem" }}>
                <BreadcrumbItem>
                    <BreadcrumbButton onClick={() => { window.location.href = "/flightops"; }}>Flight Operations</BreadcrumbButton>
                </BreadcrumbItem>
                <BreadcrumbDivider />
                <BreadcrumbItem>
                    <BreadcrumbButton onClick={() => { window.location.href = "/flightops/rings/" + params.ringName; }}>Rings | {params.ringName}</BreadcrumbButton>
                </BreadcrumbItem>
            </Breadcrumb>

            <SubPageTitle icon={<CircleMultipleConcentricFilled />} title={params.ringName} subTitle={getPageTitle( navData.subPageNavValue as string )} />

            <div className={styles.navContentRoot}>
                <TabList className={styles.navContent__tabList} vertical selectedValue={navData.subPageNavValue} onTabSelect={( _, d ) => changeTab( d.value as string )}>
                    <Tab value="overview" icon={<InfoIcon />}>Overview</Tab>
                    <Divider />
                    <Tab value="access" icon={<LockKeyIcon />}>Access Control</Tab>
                </TabList>

                <div className={styles.navContentPane}>
                    {
                        navData.subPageNavValue == "overview" ? <FlightOps_Ring_Overview /> : null
                    }
                </div>
            </div>
        </>
    );
}